import * as React from 'react'
import {
  Box,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import styled, { createGlobalStyle } from 'styled-components'
import Layout from '../components/website/Layout'
import Headers from '../components/website/sections/Header/'
import Impressum from '../components/website/legacy/Impressum'
import Footer from '../components/website/sections/Footer'

const ImpressumPage = ({ className }) => {
  return (
    <div className={className}>
      <GlobalStyle />
      <Layout
        title="Jungle Program – Impressum, Privacy Policy"
        canonical="https://www.jungleprogram.com/impressum"
        description="Jungle Program's Impressum and Privacy Policy"
      >
        <Headers />
        <Box bg={mode('gray.50')} pt="5" pb="0" mb="0" overflow="hidden">
          <Impressum />
          <Footer />
        </Box>
      </Layout>
    </div>
  )
}

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: 16px;
    background-color: #FAFAFF;
    scroll-behavior: smooth;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body, h1, h2, h3, h4, h5, h6, p, ol, ul {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  ol, ul {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    text-decoration: none;
    color: #5656ea;
  }

  ::selection {
    background: #DBDBFC;
  }

  @font-face {
    font-family: 'Tomato Grotesk';
    src:	url('./fonts/TomatoGrotesk-Semibold.eot'); /* IE9 Compat Modes */
    src:	url('./fonts/TomatoGrotesk-Semibold.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('./fonts/TomatoGrotesk-Semibold.woff2') format('woff2'), /* Super Modern Browsers */
        url('./fonts/TomatoGrotesk-Semibold.woff') format('woff'); /* Pretty Modern Browsers */
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
`;

const StyledImpressum = styled(ImpressumPage)`
  
`

export default StyledImpressum
